import moment from 'moment'
import { FLIGHTS_MAX_LEAD_TIME_DAYS, FLIGHTS_MIN_LEAD_TIME_DAYS } from 'constants/flight'

/**
 * Flight search only accepts dates from tomorrow through the configured booking
 * horizon. Trip stops can sit outside that window, so they must not prefill the
 * search drawer with a date that the flights API will reject.
 */
export function getValidFlightSearchDate(date: string | undefined): string | undefined {
  if (!date) return undefined

  const parsedDate = moment(date, 'YYYY-MM-DD', true)
  const earliestDate = moment().startOf('day').add(FLIGHTS_MIN_LEAD_TIME_DAYS, 'days')
  const latestDate = moment().startOf('day').add(FLIGHTS_MAX_LEAD_TIME_DAYS, 'days')

  return parsedDate.isBetween(earliestDate, latestDate, 'day', '[]') ? date : undefined
}
